module.exports = __webpack_public_path__ + "static/img/search.9340644.gif";